import type { BuilderContent } from '@builder.io/sdk'

import { FooterBlock } from '@/blocks/Footer'
import { AdsBottom } from '@/components/BlogLayout/AdsBottom'
import { AnalyticsProvider } from '@/core/analytics'
import type { AnalyticsData } from '@/models'
import type { ArticleSSRProps } from '@/pages/blog/[...slug]'

interface FooterLayoutProps {
  footer?: BuilderContent
  adsBottom: (BuilderContent & Pick<ArticleSSRProps, 'adsBottom'>) | null
  analytics: AnalyticsData
  url: string
}

const FooterLayout = ({ footer, adsBottom, url, analytics }: FooterLayoutProps) => (
  <>
    <AdsBottom adsBottom={adsBottom} />
    <AnalyticsProvider event={{ ...analytics, url, position: 'rodape' }}>
      <FooterBlock content={footer} />
    </AnalyticsProvider>
  </>
)
export default FooterLayout
